<script lang="ts">
import { EnumCheckboxList } from "./enum-checkbox-list.ts";
export default EnumCheckboxList;
</script>

<template>
    <app-block-ui :blocked="blocked">
        <div class="checkbox-list">
            <div class="checkbox" v-for="option in optionsHead" :key="option.id">
                <label>
                    <input
                        type="checkbox"
                        :checked="isOptionSelected(option)"
                        @change="() => toggleOption(option)"
                    />
                    <i></i>
                    <div class="checkbox-content">
                        <p>{{ option.name }}</p>
                        <p>{{ option.counter }}</p>
                    </div>
                </label>
            </div>
            <div class="btn-more" v-if="optionsTail.length" @click="() => toggleTail()">
                <svg class="sprite-icon icon btn-more__icon" width="18" height="18">
                    <use v-if="showTail" xlink:href="/img/sprite.svg#chevron-top"></use>
                    <use v-else xlink:href="/img/sprite.svg#chevron-down"></use>
                </svg>
                <span class="btn-more__text">
                    <template v-if="showTail">
                        <i18n-t keypath="ourCars.hide" />
                    </template>
                    <template v-else>
                        <i18n-t keypath="ourCars.showMore" />
                    </template>
                </span>
            </div>
            <div class="dropdown-list show" v-if="showTail">
                <div class="checkbox" v-for="option in optionsTail" :key="option.id">
                    <label>
                        <input
                            type="checkbox"
                            :checked="isOptionSelected(option)"
                            @change="() => toggleOption(option)"
                        />
                        <i></i>
                        <div class="checkbox-content">
                            <p>{{ option.name }}</p>
                            <p>{{ option.counter }}</p>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </app-block-ui>
</template>
